import { gql } from "graphql-tag";
import { useQuery } from "@vue/apollo-composable";
import { 
  SERVICE_BASIC_INFO,
  ABOUT_INFO,
  INDUSTRIES_INFO,
  OFFERS_INFO,
  TECHNOLOGIES_INFO,
  OUR_EXPERTISES_INFO,
  CLIENT_TECHNOLOGIES_INFO,
  CREDENTIALS_STATS_INFO,
  WHAT_DO_WE_OFFER_INFO,
  SCHEDULE_DEMO_INFO,
  SERVICE_BENEFITS_INFO,
  META_TAG_INFO,
  AGILE_METHOD_INFO
} from './component.queries';

export const GET_APP_BY_SLUG = gql`
  query ($slug: String!) {
    apps(filters: { slug: { eq: $slug } }) {
    name
    title
    slug
    description
    about_app {
      title
      description
      additional_info {
        title
        description
        image {
          url
        }
      }
    }
    screenshot_1 {
      url
    }
    screenshot_2 {
      url
    }
    our_expertises {
      name
      logo {
    url
      }
    }
    partners {
      name
      logo {
        url
      }
    }
    categorories {
      slug
      name
    }
    faq_categories {
      slug
      name
      faq {
        title
        description
      }
    }
    why_us {
      title
      description
      image {
        url
      }
    }
    schedule_demo {
      title
      description
      image {
        url
      }
    }
    embed_video
    what_we_offer {
      title
      description
      advantages {
        title
        description
      }
    }
dashboard_screenshots {
  url
}
key_features {
  title
features {
  title
  description
}
}
app_screens {
  url
}
clone_synonyms
alias_synonyms
keywords
    circle_image {
  url
}
tech_notes
demo_notes
demo_notes
version_notes
  }
  
}
`;

export const GET_NAV_MENU_DATA = gql`
  query GetNavMenuData {
    businessModelCategories {
      name
      slug
      business_models {
        name
        slug
      }
    }
    products {
      name
      slug
    }
      services {
      name
      slug
    }
    industries {
      name
      slug
    }
     technologiesCategories {
    name
    slug
     technologies {
      name
     slug
    }
  }
  }
`;

export const GET_BLOGS = gql`
query MeanderSoftwareBlogs($pagination: PaginationArg) {
  meanderSoftwareBlogs(pagination: $pagination) {
    title
    slug
    image {
      url
      alternativeText
    }
    publishedAt
  }
  meanderSoftwareBlogs_connection {
    pageInfo {
      total
      pageCount
    }
  }
}
`;

export const GET_SERVICES_BY_SLUG = gql`
  query ($slug: String!) {
    services(filters: { slug: { eq: $slug } })  {
      ...ServiceBasicInfo
      ...AboutInfo
      ...IndustriesInfo
      ...OffersInfo
      ...TechnologiesInfo
      ...OurExpertisesInfo
      ...ClientTechnologiesInfo
      ...CredentialsStatsInfo
      ...WhatDoWeOfferInfo
      ...ScheduleDemoInfo
      ...ServiceBenefitsInfo
      ...MetaTagInfo
      ...AgileMethodInfo
    }
  }
  ${SERVICE_BASIC_INFO}
  ${ABOUT_INFO}
  ${INDUSTRIES_INFO}
  ${OFFERS_INFO}
  ${TECHNOLOGIES_INFO}
  ${OUR_EXPERTISES_INFO}
  ${CLIENT_TECHNOLOGIES_INFO}
  ${CREDENTIALS_STATS_INFO}
  ${WHAT_DO_WE_OFFER_INFO}
  ${SCHEDULE_DEMO_INFO}
  ${SERVICE_BENEFITS_INFO}
  ${META_TAG_INFO}
  ${AGILE_METHOD_INFO}
`;

export const GET_INDUSTRY_BY_SLUG = gql`
  query ($slug: String!) {
    services(filters: { slug: { eq: $slug } })  {
      ...ServiceBasicInfo
      ...AboutInfo
      ...IndustriesInfo
      ...OffersInfo
      ...TechnologiesInfo
      ...OurExpertisesInfo
      ...ClientTechnologiesInfo
      ...CredentialsStatsInfo
      ...WhatDoWeOfferInfo
      ...ScheduleDemoInfo
      ...ServiceBenefitsInfo
      ...MetaTagInfo
      ...AgileMethodInfo
    }
  }
  ${SERVICE_BASIC_INFO}
  ${ABOUT_INFO}
  ${INDUSTRIES_INFO}
  ${OFFERS_INFO}
  ${TECHNOLOGIES_INFO}
  ${OUR_EXPERTISES_INFO}
  ${CLIENT_TECHNOLOGIES_INFO}
  ${CREDENTIALS_STATS_INFO}
  ${WHAT_DO_WE_OFFER_INFO}
  ${SCHEDULE_DEMO_INFO}
  ${SERVICE_BENEFITS_INFO}
  ${META_TAG_INFO}
  ${AGILE_METHOD_INFO}
`;


export const GET_TECHNOLOGY_BY_SLUG = gql`
  query ($slug: String!) {
    services(filters: { slug: { eq: $slug } })  {
      ...ServiceBasicInfo
      ...AboutInfo
      ...IndustriesInfo
      ...OffersInfo
      ...TechnologiesInfo
      ...OurExpertisesInfo
      ...ClientTechnologiesInfo
      ...CredentialsStatsInfo
      ...WhatDoWeOfferInfo
      ...ScheduleDemoInfo
      ...ServiceBenefitsInfo
      ...MetaTagInfo
      ...AgileMethodInfo
    }
  }
  ${SERVICE_BASIC_INFO}
  ${ABOUT_INFO}
  ${INDUSTRIES_INFO}
  ${OFFERS_INFO}
  ${TECHNOLOGIES_INFO}
  ${OUR_EXPERTISES_INFO}
  ${CLIENT_TECHNOLOGIES_INFO}
  ${CREDENTIALS_STATS_INFO}
  ${WHAT_DO_WE_OFFER_INFO}
  ${SCHEDULE_DEMO_INFO}
  ${SERVICE_BENEFITS_INFO}
  ${META_TAG_INFO}
  ${AGILE_METHOD_INFO}
`;


export function useGetAppBySlug(slug) {
  return useQuery(GET_APP_BY_SLUG, { slug });
}

export function useGetServicesBySlug(slug) {
  return useQuery(GET_SERVICES_BY_SLUG, { slug });
}

export function useGetNavMenuData() {
  return useQuery(GET_NAV_MENU_DATA);
}
export function useGetBlogs(PaginationArg) {
  return useQuery(GET_BLOGS,PaginationArg);
}



